document.addEventListener("DOMContentLoaded", function () {
    const $slider = $('.quality-bar-wrapper.slider-init');
    if ($slider.length) {
      $slider.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay:true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }


   const buttons = document.querySelectorAll('.step-tab-button');
    const contents = document.querySelectorAll('.step-tabs-inner-content');

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        // Remove active classes
        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        // Add active to clicked
        this.classList.add('active');
        const tabId = this.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
      });
    });
  });
$(document).ready(function () {
  $("#float-cart-btn").click(function () {
  $(".subscription-addtocart-btn").trigger("click");
      
});

 
   $('.buy-cstm-content').on('click', function () {
   $(".shopify-payment-button__button--unbranded").click();
      
  });
 $(window).on('scroll', function () {
    var footerOffset = $('.shopify-section-group-footer-group').offset().top;
    var scrollPosition = $(window).scrollTop() + $(window).height();

    if (scrollPosition >= footerOffset) {
        $('.floating-content').addClass('floating-content-visible');
    } else {
        $('.floating-content').removeClass('floating-content-visible');
    }
});
$('.mobile-explorebtn-bgproducts-section').click(function () {
    $('html, body').animate({
      scrollTop: $('.cstm-tab-steps').offset().top
    }, 1200); 
  });
  $(".accordion-btn").click();
//   $('.multivideo').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
  
//   ]
// });
});
$(document).ready(function () {
  var $slider = $('.multivideo');
  var slideCount = $slider.find('.video-wrapper-inner').length;

  if (slideCount > 5) {
    $slider.slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  } else if (slideCount > 1) {
    // For mobile: enable slick only if multiple slides exist
    $slider.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: slideCount,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true // allow dots only on mobile if >1 slide
          }
        }
      ]
    });
  }
});



